import { NgModule } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { ApplicationRoutingModule } from './routing/routing.module';
import { ApplicationComponent } from './application.component';
import { RegistrationModule } from '../registration/registration.module';
import { AccessService } from './services/AccessService';
import { SignInModule } from '../sign-in/sign-in.module';
import { ThemeService } from './services/ThemeService';
import { NotificationService } from './services/NotificationService';

@NgModule({
  declarations: [
    ApplicationComponent,
  ],
  imports: [
    BrowserModule,
    ApplicationRoutingModule,
    RegistrationModule,
    SignInModule,
  ],
  providers: [
    provideHttpClient(),
    AccessService,
    NotificationService,
    ThemeService,
  ],
  bootstrap: [
    ApplicationComponent,
  ],
})
export class ApplicationModule { }
